import React, { Fragment, useEffect, useState } from 'react'

import Divider from '@material-ui/core/Divider'
import { makeStyles } from '@material-ui/core/styles'
import Tab from '@material-ui/core/Tab'
import Tabs from '@material-ui/core/Tabs'
import { useTranslate, Loading } from 'react-admin'

import tracker from '../../utils/tracker'
import {
  AdvancedInvoicesEmpty,
  DelayedInvoicesEmpty,
  LateInvoicesEmpty,
  PaidInvoicesEmpty,
} from '../emptyViews/invoiceEmptyViews'
import { AdvancedDatagrid, PaidDatagrid } from './invoiceDatagrids'

const TAB_NAMES = {
  ADVANCED: 'advanced',
  DELAYED: 'delayed',
  LATE: 'late',
  PAID: 'paid',
}

const useStyles = makeStyles((theme) => ({
  scrollPanel: {
    display: 'flex',
    overflowY: 'scroll',
    overflowX: 'scroll',
    width: '100%',
    maxHeight: '67.5vh',
  },
  tabPanel: {
    width: '100%',
  },
  [theme.breakpoints.down('sm')]: {
    scrollPanel: {
      maxWidth: '80vw',
    },
  },
}))

export const InvoiceTabbedDatagrid = (props) => {
  const classes = useStyles()
  const translate = useTranslate()
  const tabs = [
    {
      id: 'advanced',
      name: 'ADVANCED',
      value: 'advanced',
      title: translate('resources.invoices.tabs.advanced'),
    },
    {
      id: 'delayed',
      name: 'DELAYED',
      value: 'delayed',
      title: translate('resources.invoices.tabs.delayed'),
    },
    {
      id: 'late',
      name: 'LATE',
      value: 'late',
      title: translate('resources.invoices.tabs.late'),
    },
    {
      id: 'paid',
      name: 'PAID',
      value: 'paid',
      title: translate('resources.invoices.tabs.paid'),
    },
  ]

  const [tabState, setTabState] = useState({
    advanced: [],
    paid: [],
    defaulted: [],
  })
  const [filterChanged, setFilterChanged] = useState()

  const {
    filterValues,
    setFilters,
    total,
    invoiceCount,
    loading,
    onChangeList,
  } = props

  useEffect(() => {
    if (onChangeList)
      onChangeList({
        total,
        loading,
      })
  }, [total, loading, onChangeList])

  if (filterValues.tabName === undefined) {
    filterValues.tabName = 'advanced'
  }

  if (props.ids !== tabState[filterValues.tabName.toLowerCase()]) {
    setTabState({
      ...tabState,
      [filterValues.tabName.toLowerCase()]: props.ids,
    })
  }

  const handleChange = (_, value) => {
    if (value !== undefined) {
      tracker.event({
        action: `${value.toLowerCase()}_tab_clicked`,
        category: 'invoicesSection',
      })
    }

    setFilters({ ...filterValues, tabName: value })
    setFilterChanged(true)
  }

  if (!filterChanged && filterValues.tabName) {
    setFilters({ ...filterValues, tabName: filterValues.tabName })
    setFilterChanged(true)
  }

  if (!filterChanged) return <Loading />

  return (
    <Fragment>
      <Tabs
        value={filterValues.tabName}
        indicatorColor="primary"
        onChange={handleChange}
        className={classes.tabPanel}
      >
        {tabs.map((choice) => {
          return (
            <Tab
              key={choice.id}
              label={`${choice.title}${
                invoiceCount && invoiceCount[choice.value]
                  ? ` (${invoiceCount[choice.value]})`
                  : ``
              }`}
              title={`${choice.title}${
                invoiceCount && invoiceCount[choice.value]
                  ? ` (${invoiceCount[choice.value]})`
                  : ``
              }`}
              value={choice.value}
            />
          )
        })}
      </Tabs>
      <Divider />
      <div>
        {filterValues.tabName === TAB_NAMES.ADVANCED &&
          total > 0 &&
          !loading && (
            <AdvancedDatagrid {...props} ids={tabState['advanced']} />
          )}
        {filterValues.tabName === TAB_NAMES.ADVANCED && !total && !loading && (
          <AdvancedInvoicesEmpty invoiceCount={invoiceCount} />
        )}
        {filterValues.tabName === TAB_NAMES.DELAYED &&
          total > 0 &&
          !loading && <AdvancedDatagrid {...props} ids={tabState['delayed']} />}
        {filterValues.tabName === TAB_NAMES.DELAYED && !total && !loading && (
          <DelayedInvoicesEmpty invoiceCount={invoiceCount} />
        )}
        {filterValues.tabName === TAB_NAMES.LATE && total > 0 && !loading && (
          <AdvancedDatagrid {...props} ids={tabState['late']} />
        )}
        {filterValues.tabName === TAB_NAMES.LATE && !total && !loading && (
          <LateInvoicesEmpty invoiceCount={invoiceCount} />
        )}
        {filterValues.tabName === TAB_NAMES.PAID && total > 0 && !loading && (
          <PaidDatagrid {...props} ids={tabState['paid']} />
        )}
        {filterValues.tabName === TAB_NAMES.PAID && !total && !loading && (
          <PaidInvoicesEmpty invoiceCount={invoiceCount} />
        )}
      </div>
    </Fragment>
  )
}
